'use strict';

function isRef(obj,key) {
    return ((key === '$ref') && (!!obj && typeof obj[key] === 'string'));
}

module.exports = {
    isRef: isRef
};

